import { render } from "./MdCheckbox.vue?vue&type=template&id=2b0a2e02"
import script from "./MdCheckbox.vue?vue&type=script&lang=js"
export * from "./MdCheckbox.vue?vue&type=script&lang=js"

import "./MdCheckbox.vue?vue&type=style&index=0&id=2b0a2e02&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__